import { DateUtils, SessionStorageUtils } from '../index';


export const CurrentAccommodationSearchSessionStorage = {
    getAccommodationCurrentSearch() {
        return (
            SessionStorageUtils.getJSON('accommodationCurrentSearch') || {
                destination: {},
                dates: {},
                rooms: [],
            }
        );
    },
    setDates({ date, id, segments }) {
        const accommodationCurrentSearch = this.getAccommodationCurrentSearch();

        const isCheckinOrCheckout = segments[0]?.id === id ? 'checkin' : 'checkout';

        if (isCheckinOrCheckout) {
            const destinationDate = isCheckinOrCheckout === 'checkin' && segments[1] && DateUtils.compare(date, segments[1].date) > 0
                ? {}
                : { checkout: {} };
            accommodationCurrentSearch.dates = {
                ...accommodationCurrentSearch.dates,
                ...destinationDate,
                [isCheckinOrCheckout]: DateUtils.toString(date)
            };
            SessionStorageUtils.setJSON('accommodationCurrentSearch', accommodationCurrentSearch);
        }
    },
    setSegment(newValues) {
        const accommodationCurrentSearch = this.getAccommodationCurrentSearch();

        if (newValues?.destination) {
            accommodationCurrentSearch.destination = newValues.destination;
        }
        if (newValues?.dates) {
            accommodationCurrentSearch.dates = { ...accommodationCurrentSearch.dates, ...newValues.dates };
        }
        if (newValues?.rooms) {
            accommodationCurrentSearch.rooms = [...accommodationCurrentSearch.rooms, ...newValues.rooms];
        }
        SessionStorageUtils.setJSON('accommodationCurrentSearch', accommodationCurrentSearch);
    },
    setRooms(newRoom) {
        const accommodationCurrentSearch = this.getAccommodationCurrentSearch();
        const rooms = accommodationCurrentSearch.rooms;

        const existingRoom = rooms.find((r) => r.id === newRoom.id);
        if (existingRoom) {
            accommodationCurrentSearch.rooms = rooms.map((r) => r.id === newRoom.id ? newRoom : r);
        } else {
            accommodationCurrentSearch.rooms = [...rooms, newRoom];
        }
        SessionStorageUtils.setJSON('accommodationCurrentSearch', accommodationCurrentSearch);
    },
    deleteRoom(room) {
        const accommodationCurrentSearch = this.getAccommodationCurrentSearch();
        const rooms = accommodationCurrentSearch.rooms;

        accommodationCurrentSearch.rooms = rooms.filter((r) => r.id !== room.id);

        SessionStorageUtils.setJSON('accommodationCurrentSearch', accommodationCurrentSearch);
    },
    setInitialState(initialState) {
        SessionStorageUtils.setJSON('accommodationCurrentSearch', {
            destination: {},
            dates: {},
            rooms: [],
            ...initialState,
        });
    }
};
